import {getDeprecatedZipCodes, validateSelectedZipCodeAddress} from '@web/actions/deliveryInfo'
import {initOrderSheetByStorage} from '@web/actions/orderSheetInfo'
import {DELIVERY_MEMO} from '@web/core/constants'
import {decodeHtmlEntities as decode} from '@web/helpers/htmlEntities'
import makeSlice from '@web/slices/deliveryInfo/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'
import {DeliveryAddressBook} from '../../apis/interface/response/interface'
import {convertDeliveryAddress} from '../../utils/delivery'

const getDeliveryAddressBookByApi = (): DeliveryAddressBook => {
    return {
        defaultDeliveryAddress: null,
        restrictedVirtualPhoneNumbers: [],
        onVirtualPhoneNumber: false,
        recentUsedDeliveryMemosReuse: [],
    }
}

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByStorage.fulfilled, (state, {payload}) => {
                if (!state.deliveryNothingOrder) {
                    const addressInfo = payload.data.deliveryInfo.selected.addressInfo

                    if (addressInfo) {
                        state.selected.addressInfo = addressInfo
                    }

                    state.pickup = payload.data.deliveryInfo.pickup
                    state.selected.recipient = payload.data.deliveryInfo.selected.recipient
                }
                /** 수신자 메모 복원 */
                state.memo = payload.data.deliveryInfo.memo
            })
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {
                    restrictedVirtualPhoneNumbers,
                    onVirtualPhoneNumber,
                    recentUsedDeliveryMemosReuse,
                    defaultDeliveryAddress,
                } = payload.deliveryAddressBook ?? getDeliveryAddressBookByApi()
                state.deliveryNothingOrder = payload.deliveryNothingOrder
                state.virtualPhoneNumber.onVirtualPhoneNumber = onVirtualPhoneNumber ?? false
                state.virtualPhoneNumber.restrictedVirtualPhoneNumbers = restrictedVirtualPhoneNumbers

                const memoList = recentUsedDeliveryMemosReuse.map(({memo, reuseMemo, template, memoSeq}) => {
                    return {
                        value: decode(memo),
                        reuse: reuseMemo,
                        template,
                        sequenceNumber: memoSeq,
                    }
                })
                state.memo.list = memoList

                // 메모 중 다음에도 사용할 메모가 있는 경우 통합메모에 초기화
                const memoToReuse = memoList?.find(({reuse}) => reuse)
                if (memoToReuse) {
                    state.memo.individuallyInput = {
                        type: memoToReuse.template ? DELIVERY_MEMO.COMMON : DELIVERY_MEMO.WRITTEN,
                        value: memoToReuse.value,
                    }
                    state.memo.saveAsDefaultMemo = true
                }

                const deliveryAddress = convertDeliveryAddress(defaultDeliveryAddress)

                state.hasDefaultAddress = deliveryAddress?.isPrimaryAddress ?? false
                state.selected.addressInfo = deliveryAddress
                state.hasOverseasDeliveryProduct = payload.isOverseasDelivery
            })
            .addCase(getDeprecatedZipCodes.fulfilled, (state, {payload}) => {
                state.deprecatedZipCodes = payload
            })
            .addCase(validateSelectedZipCodeAddress.fulfilled, (state, {payload}) => {
                state.zipCodeValidation.validationFailType = payload.validationFailType
            })
    },
})

export default slice.reducer
